









import { defineComponent } from '@vue/composition-api';

const name = 'ttam-targeting-expansion-types-container';

export default defineComponent({
  name,
  props: {
    description: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      name,
    };
  },
});
